export const GAS_SPEEDS: string[] = ['slow', 'medium', 'fast', 'ape']
